import { SectionHeader } from "../SharedComponents";
import * as React from "react";
import { TaxResidency } from "./TaxResidency";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../Resource/EWizardLinterHelper";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isEmpty } from "lodash";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";

interface ITaxDetailFatcaProps extends IProcessComponentProps {
    onCCMChange: (changes) => void;
    data: FullClientDetailModel;
    disableWhenFullClient: boolean;
    isAddNewProduct?: boolean;
    existingClientInfo?: FullClientDetailModel;
    disableHeader?: boolean;
    existingCustomer?: boolean;
}

interface ITaxDetailFatcaState {
    disableTax: boolean;
    taxResidencyOtherThanUK: boolean;
    residencies: CustomerTaxResidencyModel[];
}

export class TaxDetailFatca extends ProcessComponent<ITaxDetailFatcaProps, ITaxDetailFatcaState> {
    constructor(props: ITaxDetailFatcaProps) {
        super(props);
        this.state = {
            disableTax: false,
            taxResidencyOtherThanUK: props?.data?.CustomerTaxResidencyDetails?.some(
                (x) => x?.Country !== CountryCode.GBR && x?.IsTaxResident == true
            ),
            residencies: props.data.CustomerTaxResidencyDetails.filter((entry) => {
                return entry.IsTaxResident;
            }).map(
                (entry): CustomerTaxResidencyModel => {
                    return {
                        Country: entry.Country,
                        IsTaxResident: entry.IsTaxResident,
                        PrimaryTaxResidency: entry.PrimaryTaxResidency,
                        TaxReferenceType: entry.TaxReferenceType,
                        TaxReference: entry.TaxReference,
                        TaxResidencyForPensionRelief: entry.TaxResidencyForPensionRelief,
                        TaxExempt: entry.TaxExempt,
                        TaxExemptionReason: entry.TaxExemptionReason,
                    };
                }
            ),
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.checkDisableStatus();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.data?.ActorId !== this.props.data?.ActorId && this.props.disableWhenFullClient == true) {
            this.checkDisableStatus();
        }

        if (
            this.props.data.CustomerTaxResidencyDetails.length > 0 ||
            prevProps.data?.ActorId !== this.props.data?.ActorId
        ) {
            const { CustomerTaxResidencyDetails } = this.props.data;
            if (
                this.props.data?.CustomerTaxResidencyDetails?.length !=
                prevProps.data?.CustomerTaxResidencyDetails?.length
            ) {
                const residencies = CustomerTaxResidencyDetails.filter((entry) => {
                    return entry.IsTaxResident;
                }).map(
                    (entry): CustomerTaxResidencyModel => {
                        return {
                            Country: entry.Country,
                            IsTaxResident: entry.IsTaxResident,
                            PrimaryTaxResidency: entry.PrimaryTaxResidency,
                            TaxReferenceType: entry.TaxReferenceType,
                            TaxReference: entry.TaxReference,
                            TaxResidencyForPensionRelief: entry.TaxResidencyForPensionRelief,
                            TaxExempt: entry.TaxExempt,
                            TaxExemptionReason: entry.TaxExemptionReason,
                        };
                    }
                );
                if (this.state.residencies.length !== residencies.length) {
                    this.setState({
                        residencies: residencies,
                        taxResidencyOtherThanUK: residencies.some((residency) => residency.Country !== CountryCode.GBR),
                    });
                }
            } else if (
                CustomerTaxResidencyDetails[0].TaxReference !== this.state.residencies?.[0]?.TaxReference &&
                this.state.residencies?.[0]?.Country == CountryCode.GBR
            ) {
                // NI number is always on the UK entry and this is always the first entry
                const { residencies } = this.state;
                residencies[0].TaxReference = CustomerTaxResidencyDetails[0].TaxReference;
            }
        }
    }

    private checkDisableStatus() {
        if (this.props.disableWhenFullClient) {
            this.setState({
                disableTax: this.getBlockStatus(this.props.existingClientInfo) == EWizardLinterStatus.PleaseCheck,
            });
        }
        if (this.props.isAddNewProduct) {
            this.setState({
                disableTax: true,
            });
        }
    }

    getBlockStatus(data: FullClientDetailModel): EWizardLinterStatus {
        let complete =
            data?.EmploymentDetails?.IndividualEmploymentStatus != null &&
            data?.CustomerTaxResidencyDetails?.findIndex((x) => !this.validateCountry(x)) == -1;
        if (complete) {
            complete =
                data?.CustomerTaxResidencyDetails.some((x) => x.IsNationality == true) &&
                data?.CustomerTaxResidencyDetails.some((x) => x.IsTaxResident == true) &&
                data?.CustomerTaxResidencyDetails.some((x) => x.PrimaryCitizenship != null);
        }
        if (complete && data?.EmploymentDetails?.IsCrownEmployeeOrArmedForce == false) {
            complete = data?.CustomerTaxResidencyDetails.some(
                (x) =>
                    x?.Country != CountryCode.GBR &&
                    ((x?.IsTaxResident == true && !CommonHelper.isNullOrEmpty(x?.TaxReference)) ||
                        (x?.IsNationality && !CommonHelper.isNullOrEmpty(x?.PassportNumber)))
            );
        }
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    validateCountry(data: CustomerTaxResidencyModel): boolean {
        if (isEmpty(data)) {return true;}
        if (data?.Country != null && data?.Country == CountryCode.GBR) {
            return data?.IsTaxResident != null && data?.PrimaryTaxResidency != null;
        } else {
            if (data?.Country == null && (data?.PrimaryTaxResidency == null || data?.PrimaryCitizenship == null)) {
                return false;
            }
            if (data?.IsTaxResident && data?.IsTaxResident == true) {
                return data?.TaxReference != null;
            }
            if (data?.IsNationality && data?.IsNationality == true) {
                return (
                    !CommonHelper.isNullOrEmpty(data?.NationalIdentifier) ||
                    !CommonHelper.isNullOrEmpty(data?.PassportNumber)
                );
            }
        }
        return false;
    }

    private onResidencyChange(changes) {
        this.setState({ residencies: changes }, this.updateCustomerTaxData);
    }

    private updateCustomerTaxData() {
        const ctdChanges = this.state.residencies.filter((residency) => {
            return residency.Country;
        });

        this.props.onCCMChange([{ value: ctdChanges, path: "CustomerTaxResidencyDetails" }]);
    }

    render() {
        const { data } = this.props;
        const { disableTax } = this.state;
        const employmentDetails = data.EmploymentDetails;

        return (
            <WizardLinter
                status={this.getBlockStatus(this.props.data)}
                enabled={this.props.disableHeader ? false : true}
            >
                {!this.props.disableHeader && SectionHeader("Regulatory details")}

                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Does your client hold tax residency status anywhere other than the UK?"}
                    selected={this.state.taxResidencyOtherThanUK}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    disabled={disableTax}
                    onChange={(v) => {
                        this.setState({ taxResidencyOtherThanUK: v });
                        if (!v) {
                            // Remove other residencies
                            const newResidencies = this.state.residencies.filter((residency) => {
                                return residency.Country === CountryCode.GBR;
                            });
                            this.onResidencyChange(newResidencies);
                        } else {
                            // this.props.onCCMChange([
                            //     {
                            //         value: this.props?.data?.EmploymentDetails?.IsCrownEmployeeOrArmedForce
                            //             ? true
                            //             : false,
                            //         path: "EmploymentDetails.IsCrownEmployeeOrArmedForce",
                            //     },
                            // ]);
                        }
                    }}
                />

                {!employmentDetails?.IsCrownEmployeeOrArmedForce && this.state.taxResidencyOtherThanUK && (
                    <TaxResidency
                        data={this.state.residencies}
                        onChange={(v) => this.onResidencyChange(v)}
                        disableTax={disableTax}
                        onRef={(ref) => this.appendChild(ref)}
                        existingCustomer={this.props.existingCustomer}
                    />
                )}
            </WizardLinter>
        );
    }
}
